import { Box, Typography } from "@mui/material";
import ConnectedUsersSection from "./ConnectedUsersSection";
import LastLoginUserSection from "./LastLoginUserSection";
import LocalUsersSection from "./LocalUsersSection";
import { getLocalUserRows } from "./usersRows";

export default function UsersView({ entityData }) {
  const localUsers = getLocalUserRows(entityData);

  return (
    <Box display="flex" flexDirection="column" gap={3}>
      <ConnectedUsersSection entityData={entityData} />
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" gap={1} alignItems="center">
          <Typography variant="subtitle2">Local Admin Users</Typography>
        </Box>
        <LocalUsersSection
          localUsers={localUsers.filter((user) => user.isAdmin)}
          notFoundMessage="No admins found"
        />
      </Box>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box display="flex" gap={1} alignItems="center">
          <Typography variant="subtitle2">Local Non-Admin Users</Typography>
        </Box>
        <LocalUsersSection
          localUsers={localUsers.filter((user) => !user.isAdmin)}
          notFoundMessage="No users found"
        />
      </Box>
      <LastLoginUserSection entityData={entityData} />
    </Box>
  );
}
